import wx from "weixin-js-sdk"

export default wx
